import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CouponListService {
  private readonly COUPON_LIST_API = '/api/member_promotion/list';
  private readonly EXCHANGE_COUPON_API = '/api/member_promotion/take';

constructor(private http: HttpClient) {
}

  fetchCouponList () {
    return this.http.get(this.COUPON_LIST_API) as Observable<any>;
  }

  exchangeCoupon (params) {
    return this.http.post(this.EXCHANGE_COUPON_API, params) as Observable<any>;
  }

}
